import(/* webpackMode: "eager" */ "/app/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackWidget"] */ "/app/apps/web/src/components/feedback/FeedbackWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBottomBar"] */ "/app/apps/web/src/components/layout/MobileBottomBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsWatcher"] */ "/app/apps/web/src/components/providers/analytics-watcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/app/apps/web/src/components/providers/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/app/apps/web/src/components/pwa/cookie-consent-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaInstallBanner"] */ "/app/apps/web/src/components/pwa/pwa-install-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaManager"] */ "/app/apps/web/src/components/pwa/pwa-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaUpdateBanner"] */ "/app/apps/web/src/components/pwa/pwa-update-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/web/src/components/theme-provider.tsx");
